import React, { useState } from 'react';
import UserMaintenance from './UserMaintenance';
import ClientMaintenance from './ClientMaintenance';
import VendorMaintenance from './VendorMaintenance';
import ListNameMaintenance from './ListNameMaintenance';
import Icon from '../common/Icon';

const Maintenance = () => {
    const [activeTab, setActiveTab] = useState('user');

    const renderContent = () => {
        switch (activeTab) {
            case 'user':
                return <UserMaintenance />;
            case 'client':
                return <ClientMaintenance />;
            // case 'vendor':
            //     return <VendorMaintenance />;
            case 'list':
                return <ListNameMaintenance />;
            default:
                return <UserMaintenance />;
        }
    };

    return (
        <div className="maintenance-container">
            <div className="maintenance-content-section">
                {/* Header Section */}
                <div className="maintenance-section-header">
                    <h1 className="maintenance-section-title">Maintenance</h1>

                    {/* Navigation Links */}
                    <div className="maintenance-nav-links" style={{
                        display: 'flex',
                        gap: '8px',
                        marginTop: '16px',
                        paddingBottom: '12px'
                    }}>
                        <span 
                            className={`maintenance-nav-link ${activeTab === 'user' ? 'active' : 'inactive'}`}
                            onClick={() => setActiveTab('user')}
                            style={{
                                padding: '8px 16px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                transition: 'all 0.3s',
                                backgroundColor: activeTab === 'user' ? '#0a558c' : 'transparent',
                                color: activeTab === 'user' ? 'white' : '#666',
                                border: activeTab === 'user' ? 'none' : '1px solid #ddd'
                            }}
                            onMouseEnter={(e) => {
                                if (activeTab !== 'user') {
                                    e.target.style.backgroundColor = '#f5f5f5';
                                    e.target.style.color = '#333';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (activeTab !== 'user') {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.color = '#666';
                                }
                            }}
                        >
                            
                            User Maintenance
                        </span>
                        
                        <span 
                            className={`maintenance-nav-link ${activeTab === 'client' ? 'active' : 'inactive'}`}
                            onClick={() => setActiveTab('client')}
                            style={{
                                padding: '8px 16px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                transition: 'all 0.3s',
                                backgroundColor: activeTab === 'client' ? '#0a558c' : 'transparent',
                                color: activeTab === 'client' ? 'white' : '#666',
                                border: activeTab === 'client' ? 'none' : '1px solid #ddd'
                            }}
                            onMouseEnter={(e) => {
                                if (activeTab !== 'client') {
                                    e.target.style.backgroundColor = '#f5f5f5';
                                    e.target.style.color = '#333';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (activeTab !== 'client') {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.color = '#666';
                                }
                            }}
                        >
                            
                            Client Maintenance
                        </span>

                        
                        <span 
                            className={`maintenance-nav-link ${activeTab === 'list' ? 'active' : 'inactive'}`}
                            onClick={() => setActiveTab('list')}
                            style={{
                                padding: '8px 16px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                transition: 'all 0.3s',
                                backgroundColor: activeTab === 'list' ? '#0a558c' : 'transparent',
                                color: activeTab === 'list' ? 'white' : '#666',
                                border: activeTab === 'list' ? 'none' : '1px solid #ddd'
                            }}
                            onMouseEnter={(e) => {
                                if (activeTab !== 'list') {
                                    e.target.style.backgroundColor = '#f5f5f5';
                                    e.target.style.color = '#333';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (activeTab !== 'list') {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.color = '#666';
                                }
                            }}
                        >
                          
                            List Maintenance
                        </span>
                    </div>
                </div>

              

              
                <div className="maintenance-main-content">
                    {renderContent()}
                </div>
            </div>
        </div>
    );
};

export default Maintenance;